<div class="settings-general">
	<div class="button-container" *ngIf="manageOrganization">
		<div *ngIf="!editForm">
			<button *ngIf="hasAddSubOrgService" type="button" mat-button color="accent"
				class="organization-button" [disabled]="false" [routerLink]="['addSubOrg']"><span
					class="text-color" translate>add-suborg.add-suborg</span>
				<mat-icon iconPositionEnd svgIcon="plus" class="icon-color"></mat-icon>
			</button>
			<button type="button" mat-button color="accent" class="organization-button" (click)="onEdit()"
				><span class="text-color" translate>quapp.action.edit</span>
				<mat-icon iconPositionEnd svgIcon="md:edit" class="icon-color"></mat-icon>
			</button>
		</div>
		<div *ngIf="editForm">
			<button type="button" mat-button color="accent" class="organization-button cancel-button"
				(click)="onCancel()"><span class="text-color" translate>dashboard.cancel</span>
			</button>
			<button type="button" mat-button color="accent" class="organization-button" (click)="onSave()"
				[disabled]="enableSave"><span class="text-color" translate>dashboard.savechanges</span>
				<mat-icon iconPositionEnd class="icon-color" svgIcon="save_disk"></mat-icon>
			</button>
		</div>
	</div>
	<div class="grid-6" *ngIf="!isLoading else loading">
		<div class="card-block grid-column-two-third">
			<copo-organization-card-details-identity [organization]="organization" [editMode]="editForm"
				(organizationCardDetailsIdentityChange)="onOrganizationCardDetailsIdentityChange($event)"
				[supplier]="suppliers" [countries]="countries" (formCheck)="doCheck($event)">
			</copo-organization-card-details-identity>
		</div>
		<div class="card-block grid-column-one-third">
			<div class="card-title">
				<span class="card-title-label" translate>organization.card.details.administrator</span>
				<span class="card-title-comment" translate>organization.card.administrator.comment</span>
			</div>
			<div class="organization-card-infos-block">
				<div class="organization-card-info">
					<span class="organization-card-info-label" translate>organization.card.administrator.name</span>
					<div class="organization-card-info-value organization-card-info-text-corpo-color">
						<a [routerLink]="['/user/card',getAdministratorParam(),'settings','general']"
							class="organization-card-info-text-corpo-color underline">
							{{organization?.administrator?.firstName}}
							{{organization?.administrator?.lastName}}
						</a>
					</div>
				</div>
				<div class="organization-card-info">
					<div class="organization-card-info-label" translate>organization.card.administrator.email</div>
					<a class="organization-card-info-value organization-card-info-text-corpo-color underline"
						[href]="'mailto:' + administratorEmail">
						{{administratorEmail}}
					</a>
				</div>
			</div>
		</div>
		<div class="card-block grid-column-one-full">
			<div class="card-title">
				<span class="card-title-label" translate>organization.details-card.flow-chart</span>
				<span class="card-title-comment" translate>organization.details-card.flow-chart.desc</span>
			</div>
			<div class="card-infos-block">
				<div class="card-infos">
					<div class="copo-organization-flow-chart">
						<div class="copo-organization-flow-chart-graph">
							<copo-organization-flow-chart [orgIdForflowChart]="orgIdForflowChart"
								[organizationId]="organizationId"></copo-organization-flow-chart>
						</div>
						<div class="copo-organization-flow-chart-legend">
							<span class="copo-organization-flow-chart-legend-supplier"
								translate>organization.details-card.flow-chart.supplier</span>
							<span class="copo-organization-flow-chart-legend-customer"
								translate>organization.details-card.flow-chart.customer</span>
							<div class="copo-organization-flow-chart-legend-current">
								<mat-icon svgIcon="md:chevron_left"></mat-icon>
								<span translate>organization.details-card.flow-chart.current-organization</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>